module.exports = __webpack_public_path__ + "img/LockKey.99a2f13d.svg";